import axiosInstance from '@/utils/api.js'

var state = {
  systemUsers: [],
  systemUsersGroups: []
}

var getters = {
  SYSTEM_USERS: (state) => {
    return state.systemUsers
  },
  SYSTEM_USERS_GROUPS: (state) => {
    return state.systemUsersGroups
  }
}

var mutations = {
  SET_SYSTEM_USERS: (state, payload) => {
    state.systemUsers = payload
  },
  SET_SYSTEM_USERS_GROUPS: (state, payload) => {
    state.systemUsersGroups = payload
  }
}

var actions = {
  GET_SYSTEM_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/users/system_users')
    if (result.status === 200) {
      context.commit('SET_SYSTEM_USERS', result.data)
    }
  },
  CREATE_SYSTEM_USER: (context, payload) => {
    return axiosInstance.post('/users/system_users', payload)
  },
  UPDATE_SYSTEM_USER: (context, payload) => {
    return axiosInstance.put('/users/system_users', payload)
  },
  DELETE_SYSTEM_USER: (context, payload) => {
    return axiosInstance.delete('/users/system_users?sys_user_id=' + payload)
  },

  GET_SYSTEM_USERS_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/users/system_groups')
    if (result.status === 200) {
      context.commit('SET_SYSTEM_USERS_GROUPS', result.data)
    }
  },
  CREATE_SYSTEM_USERS_GROUPS: (context, payload) => {
    return axiosInstance.post('/users/system_groups', payload)
  },
  UPDATE_SYSTEM_USERS_GROUPS: (context, payload) => {
    return axiosInstance.put('/users/system_groups', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/systemUsers.js